<template>
  <div class="cps">
    <div class="cps-content">
      <div class="module-1">
        <p class="title">上海港（舱单）发送</p>
        <p class="text">随时随地随心使用、操作简单、智能审核、周末及节假日均可发送</p>
        <span class="btn" @click="openQQ">开通咨询</span>
      </div>
      <div class="module" :class="`module-${item.index}`" v-for="(item, i) in module" :key="i">
        <div class="content">
          <p class="title">{{ item.title }}</p>
          <span class="text" v-html="item.content" />
        </div>
      </div>
      <div class="module-explain">
        <div class="nav">如何发送舱单？</div>
        <div class="explain-box">
          <div :class="`explain-box-${item.type}`" v-for="(item, i) in explain" :key="i">
            <img class="number-icon" :src="item.numUrl" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="text" v-html="item.text" />
          </div>
        </div>
      </div>
      <ContactUs />
    </div>
  </div>
</template>
<script>
import ContactUs from '@/components/ContactUs'
import { openQQ } from '@/utils/common.js'
import { ossUrl } from '@/utils/config.js'
export default {
  name: 'cps',
  components: { ContactUs },
  data() {
    return {
      module: [
        {
          index: 2,
          title: '一站式 无忧邮件代发',
          content: '舱单发送，你可以有更简单的选择，用户可通过邮件形式，发送舱单数据，平台会将回执信息推送至微信/邮箱以及页面上'
        },
        {
          index: 3,
          title: '海量船司 全船代',
          content: '支持73家船公司和14家船代的舱单发送'
        },
        {
          index: 4,
          title: '智能校验 高效快捷',
          content: '无需签约，无需二次确认 <br /> 一键查看对应船代，告别反复确认 <br />系统智能校验，降低数据出错率'
        },
        {
          index: 5,
          title: '回执状态 实时推送',
          content: '无论电脑端、手机端、随时掌握舱单回执状态，支持「微信推送」「邮件推送」，精准预警，出差在外移动办公更便捷'
        }
      ],
      explain: [
        {
          type: 'left',
          numUrl: `${ossUrl}/common/introduce/number-1.png`,
          title: '开通舱单权限',
          text: '注册账号并完成企业认证， <br /> 可联系您的专属'
        },
        {
          type: 'center',
          numUrl: `${ossUrl}/common/introduce/number-2.png`,
          title: '录入舱单信息',
          text: '您可以选择「在线录入」或「Excel模版导入」录入舱单信息'
        },
        {
          type: 'right',
          numUrl: `${ossUrl}/common/introduce/number-3.png`,
          title: '手机端查看回执',
          text: '平均5分钟可接收回执'
        }
      ]
    }
  },
  methods: {
    openQQ
  }
}
</script>
<style lang="scss" scoped>
.cps {
  width: 100vw;
  overflow-x: hidden;

  .cps-content {
    width: 100%;
    min-width: 1920px;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .module-1 {
    height: 1080px;
    margin: -60px auto 0;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/cps-bg-1.png');
    background-size: 100%;
    background-repeat: no-repeat;
    text-align: center;

    .title {
      font-size: 68px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #212450;
      line-height: 95px;
      letter-spacing: 1px;
      padding-top: 118px;
    }

    .text {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #212450;
      line-height: 35px;
      letter-spacing: 3px;
      padding-top: 16px;
    }

    .btn {
      width: 180px;
      height: 64px;
      display: block;
      background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/btn.png');
      background-size: 100%;
      margin: 24px auto 0;
      line-height: 64px;
      font-weight: 600;
      color: #ffffff;
      font-size: 24px;
      cursor: pointer;
    }
  }

  .module {
    margin: 120px auto 0;
    background-repeat: no-repeat;

    .content {
      .title {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #212450;
        line-height: 45px;
        letter-spacing: 1px;
      }

      .text {
        display: inline-block;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        padding-top: 24px;
        text-align: justify;
      }
    }
  }

  .module-2 {
    height: 804px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/cps-module-2.png');
    background-size: 1411px 804px;
    background-position: 177px;

    .content {
      padding: 300px 0 0 364px;

      .text {
        display: inline-block;
        width: 322px;
        letter-spacing: 1px;
      }
    }
  }

  .module-3 {
    height: 691px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/cps-module-3.png');
    background-size: 1300px 691px;
    background-position: 305px;

    .content {
      float: right;
      padding: 334px 370px 0 0;

      .text {
        display: inline-block;
        width: 322px;
        letter-spacing: 1px;
      }
    }
  }

  .module-4 {
    height: 663px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/cps-module-4.png');
    background-size: 1255px 663px;
    background-position: 359px;

    .content {
      padding: 249px 0 0 360px;

      .text {
        width: 360px;
        font-size: 22px;
        letter-spacing: 1px;
      }
    }
  }

  .module-5 {
    height: 691px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/cps-module-5.png');
    background-size: 1170px 691px;
    background-position: 359px;

    .content {
      float: right;
      padding: 260px 350px 0 0;

      .text {
        display: inline-block;
        width: 325px;
        letter-spacing: 1px;
      }
    }
  }

  .module-explain {
    width: 1180px;
    margin: 119px auto 0;

    .nav {
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 45px;
      letter-spacing: 2px;
    }

    .explain-box {
      width: 100%;
      margin-top: 48px;
      display: flex;
      justify-content: space-between;

      & > div {
        width: 380px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 34px 34px 30px;
        color: white;

        .number-icon {
          width: 49px;
          height: 49px;
        }

        .title {
          font-size: 24px;
          padding-top: 16px;
        }

        .text {
          padding-top: 9px;
          font-size: 18px;
          line-height: 25px;
          letter-spacing: 1px;
        }
      }

      .explain-box-left {
        height: 220px;
        background: #3371ff;
      }

      .explain-box-center {
        height: 256px;
        background: #0ddabe;
      }

      .explain-box-right {
        height: 292px;
        background: #ffb817;
      }
    }
  }
}
</style>
